module.exports = __webpack_public_path__ + "img/hn.e52d6983.svg";